import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";

// OBTIENE TODA LA INFORMACION DE LOS PRODUCTOS
export const getTiposPagosClientes= async () => {
    const respuesta = PrivateInterceptor('Global/TiposPago', 'GET')
    return respuesta
};

// OBTIENER LISTADO
export const getTipoPago = async(Token) => {
    const result = await PublicInterceptor('Global/TiposPago/token', 'GET', {}, Token)
    return result;
}